import React from 'react';
import dataAids from '../../../../constants/dataAids';
import { UX2 } from '@wsb/guac-widget-core';
import { errorMessageProps } from '../../../../constants/constants';
import PropTypes from 'prop-types';

const RequiredFieldsBlankWarning = props => {
  const {
    requiredFieldsBlank,
    product,
    blankRequiredFieldsMap,
    getBlankRequiredFieldsTranslation
  } = props;
  const { Block } = UX2.Element;

  if (product && requiredFieldsBlank) {
    const blankRequiredSelectFieldNames = blankRequiredFieldsMap.selectFieldNames;
    const blankRequiredTextFieldNames = blankRequiredFieldsMap.textFieldNames;
    const selectTranslation = getBlankRequiredFieldsTranslation(
      blankRequiredSelectFieldNames,
      'select'
    );
    const textTranslation = getBlankRequiredFieldsTranslation(blankRequiredTextFieldNames, 'text');

    return (
      <Block style={{ marginBottom: 'large' }}>
        <UX2.Element.Error
          { ...errorMessageProps }
          data-aid={ dataAids.REQUIRED_SELECT_FIELDS_BLANK }
          children={ selectTranslation }
        />
        <UX2.Element.Error
          { ...errorMessageProps }
          data-aid={ dataAids.REQUIRED_TEXT_FIELDS_BLANK }
          children={ textTranslation }
        />
      </Block>
    );
  }
  return null;
};

RequiredFieldsBlankWarning.propTypes = {
  requiredFieldsBlank: PropTypes.bool,
  product: PropTypes.object,
  blankRequiredFieldsMap: PropTypes.object,
  getBlankRequiredFieldsTranslation: PropTypes.func
};

export default RequiredFieldsBlankWarning;
